export const contacts = {
  mobile1: "+919955382009",
  mobile2: "+919955382010",
  whatsApp: "919334337935",
  email: "info@deenovoschool.edu",
  address: "Naya Para, Behind A-Team Ground, Dumka- 814101, Jharkhand",
  officeVisitingTime: "Monday to Saturday, 8:00 AM to 4:00 PM",
};
